import { scroll } from './locomotive';
import { breakpoints } from '../utils/breakpoints';

const selectors = {
  header: '.js-header-alt',
};

const classNames = {
  scrolled: 'l-header--scrolled',
};

const handleProductsNav = () => {
  const header = document.querySelector(selectors.header);

  if (!header) return;

  let prevScroll = 0;
  let curScroll;

  scroll.on('scroll', (args) => {
    if (window.innerWidth < breakpoints.tablet) {
      curScroll = args.scroll.y;

      if (curScroll < 20) {
        header.classList.remove(classNames.scrolled);
      } else if (curScroll < prevScroll) {
        header.classList.remove(classNames.scrolled);
      } else {
        header.classList.add(classNames.scrolled);
      }

      prevScroll = curScroll;
    } else {
      const isFooterVisible = Object.prototype.hasOwnProperty.call(
        args.currentElements,
        'footer'
      );

      if (isFooterVisible) {
        header.classList.add(classNames.scrolled);
      } else {
        header.classList.remove(classNames.scrolled);
      }
    }
  });
};

export default handleProductsNav;
